<template>
  <div class="wrapper__initial">
    <si-landing-page
        v-if="showLanding"
    ></si-landing-page>
    <si-closed-competition
        v-if="showClosedCompetition"
        :type="'competition'"
    ></si-closed-competition>
    <si-vote
        v-if="showVote"
    ></si-vote>
    <si-closed-vote
        v-if="showClosedVote"
        :type="'vote'"
    ></si-closed-vote>
    <si-winner
        v-if="showWinner"
    ></si-winner>
  </div>
</template>

<script>
    import CONFIG from '@/config';
    import LandingPage from '@/components/LandingPage.vue';
    import Vote from '@/components/Vote.vue';
    import Closed from '@/components/Closed.vue';
    import Winner from '@/components/Winner.vue';
    import LoadingSpinner from '@/services/loading-spinner.service';
    import Preloader from '@/services/preloader.service';

    export default {

        name: 'Initial',

        computed: {

            showLanding() {
                return this.checkDates(this.dates.contest.startDate, this.dates.contest.endDate);
            },

            showClosedCompetition() {
                return this.checkDates(this.dates.contestclosed.startDate, this.dates.contestclosed.endDate);
            },

            showVote() {
                return this.checkDates(this.dates.voting.startDate, this.dates.voting.endDate);
            },

            showClosedVote() {
                return this.checkDates(this.dates.votingclosed.startDate, this.dates.votingclosed.endDate);
            },

            showWinner() {
                return this.checkDates(this.dates.winner.startDate, this.dates.winner.endDate);
            }
        },

        data() {

            return {
                currentDate: CONFIG.settings.date !== null ? new Date(CONFIG.settings.date) : new Date(),
                dates: CONFIG.settings.dates
            };
        },

        mounted() {
            const imagesPerModule = {
                mask: {
                    preload: [
                        'images/landing_container.png',
                        'images/landing_btn.png'
                    ],
                    subsequent: [
                        'images/landing_btn-hover.png',
                        'images/mask-design_logo.png',
                        'images/mask-design_mask.png',
                        'images/mask-design_startover.png',
                        'images/mask-design_startover-hover.png',
                        'images/mask-design_stickers.png',
                        'images/mask-design_submit-hover.png',
                        'images/mask-design_submit.png',
                        'images/mask-design_tools.png',
                        'images/mask-design_undo.png',
                        'images/mask-design_undo-hover.png',
                        'images/sticker1.png',
                        'images/sticker2.png',
                        'images/sticker3.png',
                        'images/sticker4.png',
                        'images/sticker5.png',
                        'images/sticker6.png',
                        'images/close.png',
                        'images/corner.png',
                        'images/mask-submission_form.png',
                        'images/mask-submission_mask.png',
                        'images/mask-submission_submit.png',
                        'images/mask-submission_submit-hover.png',
                        'images/mask-submission_submitted.png',
                    ]
                },
                closed: {
                    preload: [
                        'images/closed_competition.png',
                        'images/closed_vote.png'
                    ],
                    subsequent: []
                },
                vote: {
                    preload: [
                        'images/vote_background.png',
                        'images/vote_temp-mask_1.png',
                        'images/vote_temp-mask_2.png',
                        'images/vote_temp-mask_3.png',
                        'images/vote_temp-mask_4.png',
                        'images/vote_temp-mask_5.png',
                        'images/vote_vote.png',
                        'images/vote_initial-submit.png',
                        'images/vote_submit.png'
                    ],
                    subsequent: [
                        'images/vote_submit-hover.png',
                        'images/vote_submitted.png',
                        'images/vote_submitvote.png',
                        'images/vote_submitvote-hover.png'
                    ]
                },
                winner: {
                    preload: [],
                    subsequent: []
                }
            };
            let preload = [];
            let subsequent = [];

            if (this.showLanding) {
                preload = imagesPerModule.mask.preload;
                subsequent = imagesPerModule.mask.subsequent;
            } else if (this.showClosedCompetition || this.showClosedVote) {
                preload = imagesPerModule.closed.preload;
                subsequent = imagesPerModule.closed.subsequent;
            } else if (this.showVote) {
                preload = imagesPerModule.vote.preload;
                subsequent = imagesPerModule.vote.subsequent;
            } else {
                preload = imagesPerModule.winner.preload;
                subsequent = imagesPerModule.winner.subsequent;
            }

            LoadingSpinner.show();

            Preloader.bind(preload, {
                complete() {
                    console.log('Module Images preloaded!', preload);
                    LoadingSpinner.hide();
                },
                error() {
                    console.log('Failed to load one or more images!');
                }
            });

            Preloader.bind(subsequent, {
                complete() {
                    console.log('Module Subsequent images Loaded!', subsequent);
                },
                error() {
                    console.log('Failed to load one or more images!');
                }
            });
        },

        methods: {

            checkDates(startDate, endDate) {

                if (startDate === null && endDate !== null) {
                    return this.currentDate.getTime() < endDate.getTime();
                } else if (startDate !== null && endDate !== null) {
                    return (
                        (this.currentDate.getTime() >= startDate.getTime())
                        && (this.currentDate.getTime() < endDate.getTime())
                    );
                } else {
                    return this.currentDate.getTime() >= startDate.getTime();
                }
            }
        },

        components: {
            SiLandingPage: LandingPage,
            SiClosedCompetition: Closed,
            SiVote: Vote,
            SiClosedVote: Closed,
            SiWinner: Winner
        }
    }
</script>

<style scoped lang="scss">
    .wrapper__initial {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
</style>
